import { createReducer, on } from "@ngrx/store";
import { CityDto } from "src/app/api/models";
import * as CityActions from "./city.actions";
import { resetCity } from './city.actions';

export const cityFeatureKey = "city";

export interface CityState {
	cityList: CityDto[];
}

export const initialState: CityState = {
	cityList: undefined,
};

export const cityReducer = createReducer(
	initialState,
	on(CityActions.loadCitysByProvinceSuccess, (state, { data }) => ({ ...state, cityList: data })),
	on(CityActions.loadCitysByProvinceFailure, (state, action) => ({ ...state, loadingCitysError: action.error })),
	on(resetCity, () => initialState)
);